// You can write more code here

/* START OF COMPILED CODE */

import { CardDropSiteData } from '@/game/prefabs/StudentGame/CardDropSite.types';
import CardDropSite from './CardDropSite';
/* START-USER-IMPORTS */
import SlottedMinigameCardLayoutGroup from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/SlottedMinigameCardLayoutGroup';
import MinigameCardSlot from '@/game/prefabs/StudentGame/MinigameCardSlot';
import StudentGameCard from '@/game/prefabs/StudentGame/StudentGameCard';
import PlaceholderMinigameCard from '@/game/scenes/PlaceholderStudentGameCard';
/* END-USER-IMPORTS */

export default class SlottedCardDropSite extends CardDropSite {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // backing_1
    const backing_1 = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      416,
      160,
      4,
      4,
      4,
      4,
    );
    backing_1.visible = false;
    this.add(backing_1);

    // dropSiteCardContainer_1
    const dropSiteCardContainer_1 = scene.add.container(0, 0);
    this.add(dropSiteCardContainer_1);

    this.backing_1 = backing_1;
    this.dropSiteCardContainer_1 = dropSiteCardContainer_1;

    /* START-USER-CTR-CODE */
    // This is a side-effect of phaser editor inheritance but essentially we need
    // seperate references to the same object in child and parent.
    // Dumb but it works.
    this.backing = backing_1;
    this.dropSiteCardContainer = dropSiteCardContainer_1;
    /* END-USER-CTR-CODE */
  }

  public backing_1: Phaser.GameObjects.NineSlice;
  private dropSiteCardContainer_1: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  override init(data: CardDropSiteData) {
    this.layoutGroup = new SlottedMinigameCardLayoutGroup({
      parent: this.dropSiteCardContainer_1,
      elementDist: 4,
      maxCards: 6,
      origin: { x: 0, y: 0 },
      realignmentType: 'animated',
      maxWidth: 1024,
    });

    super.init(data);

    // Initialize the placeholder card.
    this.placeholderCard = new PlaceholderMinigameCard(this.scene, 0, 0);
    this.scene.add.existing(this.placeholderCard);
    this.placeholderCard.setVisible(false);

    return this;
  }

  override dropCard(card: StudentGameCard, index: number) {
    // Stop showing the candidate placement.
    this.removeCandidatePlacement();
    const droppedCardOriginIndex = card.origin?.index;
    // Try to add the card to the index.
    const didAddCard = this.addCard(card, index);
    if (!didAddCard) {
      if (card.origin) {
        this.addCard(card, droppedCardOriginIndex || 0);
      } else {
        console.error(`Couldn't drop card`, card, `at index`, index);
      }
    }
  }

  override addCard(
    card: StudentGameCard | PlaceholderMinigameCard,
    index: number,
    realignmentOverride?: 'instant' | 'animated',
  ): boolean {
    const addedCard = this.getLayoutGroup().addCard(
      card,
      index,
      realignmentOverride,
    );

    // Set the card's origin.
    if (card instanceof StudentGameCard) {
      card.origin = {
        dropSite: this,
        index: index,
      };
    }

    return addedCard || false;
  }

  override removeCard(card: StudentGameCard | PlaceholderMinigameCard) {
    this.getLayoutGroup().removeCard(card);
  }

  override displayCandidatePlacement(index: number, card: StudentGameCard) {
    if (!this.placeholderCard) return;
    // if (this.getLayoutGroup().cards[index] === this.placeholderCard) return;
    this.placeholderCard.setVisible(true);
    this.placeholderCard.setRepresentingMinigameCard(card);

    if (this.getLayoutGroup().findCard(this.placeholderCard)) {
      this.getLayoutGroup().moveCard(this.placeholderCard, index);
    } else {
      this.addCard(this.placeholderCard, index);
    }
  }

  override removeCandidatePlacement() {
    if (!this.placeholderCard) return;
    this.removeCard(this.placeholderCard);
    this.placeholderCard.setVisible(false);
    this.getLayoutGroup().updateLayout();
  }

  override updateMaxCards(newMax: number) {
    super.updateMaxCards(newMax);
    for (var i = 0; i < this.getLayoutGroup().cards.length; i++) {
      const card = this.getLayoutGroup().cards[i];
      if (card instanceof MinigameCardSlot) {
        this.getLayoutGroup().removeSlot(i);
      }
    }
    this.getLayoutGroup().updateLayout();
  }

  transferCard(
    card: StudentGameCard,
    toDropSite: CardDropSite,
    toIndex: number,
  ) {
    super.transferCard(card, toDropSite, toIndex);
  }

  getLayoutGroup(): SlottedMinigameCardLayoutGroup {
    return this.layoutGroup as SlottedMinigameCardLayoutGroup;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
